export default "__VITE_PUBLIC_ASSET__5046b395__"